// extracted by mini-css-extract-plugin
module.exports = {"container":"Buttons_container__1xvGc","secondary":"Buttons_secondary__WIoBN","primary":"Buttons_primary__2y0sl"};